// extracted by mini-css-extract-plugin
export default {"form":"AuthForm_form__z+dVW","submit":"AuthForm_submit__pTEOo","links":"AuthForm_links__yidTK","textLink":"AuthForm_textLink__unwNK","email":"AuthForm_email__PwRXA"};